import { render, staticRenderFns } from "./activeintroduce.vue?vue&type=template&id=5a86b249&scoped=true&"
import script from "./activeintroduce.vue?vue&type=script&lang=js&"
export * from "./activeintroduce.vue?vue&type=script&lang=js&"
import style0 from "./activeintroduce.vue?vue&type=style&index=0&id=5a86b249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86b249",
  null
  
)

export default component.exports